export default class Parameter {
    constructor(parameters) {

        this.ActiveDirectoryAllowedUserGroups = "";
        this.ActiveDirectoryAuthEnabled = false;
        this.AzureUseActiveDirectory = false;
        this.AzureMicrosoftGraphApiURL = "";
        this.ActiveDirectoryDomain = "";
        this.ActiveDirectoryServerPath = "";
        this.ClientID = "";
        this.CredentialID = "";
        this.ClientSecret = "";
        this.UserID = "";
        this.QuoVadisV2ApiURL = "";
        this.DashboardCacheEnabled = false;
        this.JobsExecutionTimeDocumentLifeCycle = "";
        this.JobsExecutionTimeDelegations = "";
        this.JobsExecutionTimeDataManagement = "";
        this.JobsExecutionTimeAlert = "";
        this.JobsExecutionTimeLicence = "";
        this.JobsExecutionTimeConnectedServices = "";
        this.SAMLEnabled = false;
        this.SAMLCertificate = "";
        this.SAMLEndpoint = "";
        this.SupportedFileFormats = "";
        this.WebApiURL = "";
        this.AutorecognitionApiURL = "";
        this.WebsiteURL = "";
        this.SwissIDEnabled = false;
        this.SwissIDLogin = "";
        this.SwissIDPassword = "";
        this.MicrosoftEntraClientId = "";
        this.MicrosoftEntraClientSecret = "";
        this.MicrosoftEntraIDDefaultOrganizationId = "";


        if (parameters) {
            this.ActiveDirectoryAllowedUserGroups = parameters.find(p => p.Name == 'ActiveDirectoryAllowedUserGroups').Value;
            this.ActiveDirectoryAuthEnabled = parameters.find(p => p.Name == 'ActiveDirectoryAuthEnabled').Value == "true";
            this.AzureUseActiveDirectory = parameters.find(p => p.Name == 'AzureUseActiveDirectory').Value == "true";
            this.AzureMicrosoftGraphApiURL = parameters.find(p => p.Name == 'AzureMicrosoftGraphApiURL').Value;
            this.ActiveDirectoryDomain = parameters.find(p => p.Name == 'ActiveDirectoryDomain').Value;
            this.ActiveDirectoryServerPath = parameters.find(p => p.Name == 'ActiveDirectoryServerPath').Value;
            this.ClientID = parameters.find(p => p.Name == 'ClientID').Value
            this.CredentialID = parameters.find(p => p.Name == 'CredentialID').Value
            this.ClientSecret = parameters.find(p => p.Name == 'ClientSecret').Value
            this.UserID = parameters.find(p => p.Name == 'UserID').Value
            this.QuoVadisV2ApiURL = parameters.find(p => p.Name == 'QuoVadisV2ApiURL').Value
            this.DashboardCacheEnabled = parameters.find(p => p.Name == 'DashboardCacheEnabled').Value == "true";
            this.JobsExecutionTimeDocumentLifeCycle = parameters.find(p => p.Name == 'JobsExecutionTimeDocumentLifeCycle').Value;
            this.JobsExecutionTimeDelegations = parameters.find(p => p.Name == 'JobsExecutionTimeDelegations').Value;
            this.JobsExecutionTimeDataManagement = parameters.find(p => p.Name == 'JobsExecutionTimeDataManagement').Value;
            this.JobsExecutionTimeAlert = parameters.find(p => p.Name == 'JobsExecutionTimeAlert').Value;
            this.JobsExecutionTimeLicence = parameters.find(p => p.Name == 'JobsExecutionTimeLicence').Value;
            this.JobsExecutionTimeConnectedServices = parameters.find(p => p.Name == 'JobsExecutionTimeConnectedServices').Value;
            this.SAMLCertificate = parameters.find(p => p.Name == 'SAMLCertificate').Value;
            this.SAMLEndpoint = parameters.find(p => p.Name == 'SAMLEndpoint').Value;
            this.SAMLEnabled = (this.SAMLCertificate && this.SAMLEndpoint);
            this.SupportedFileFormats = parameters.find(p => p.Name == 'SupportedFileFormats').Value;
            this.WebApiURL = parameters.find(p => p.Name == 'WebApiURL').Value;
            this.AutorecognitionApiURL = parameters.find(p => p.Name == 'AutorecognitionApiURL').Value;
            this.WebsiteURL = parameters.find(p => p.Name == 'WebsiteURL').Value;
            this.SwissIDLogin = parameters.find(p => p.Name == 'SwissIDLogin').Value;
            this.SwissIDPassword = parameters.find(p => p.Name == 'SwissIDPassword').Value;
            this.SwissIDEnabled = (this.SwissIDLogin && this.SwissIDPassword);
            this.MicrosoftEntraClientId = parameters.find(p => p.Name == 'MicrosoftEntraClientId').Value;
            this.MicrosoftEntraClientSecret = parameters.find(p => p.Name == 'MicrosoftEntraClientSecret').Value;
            this.MicrosoftEntraIDDefaultOrganizationId = parameters.find(p => p.Name == 'MicrosoftEntraIDDefaultOrganizationId').Value;
        }
    }

    toDto() {
        var parameters = [];
        parameters.push({ Name: "ActiveDirectoryAllowedUserGroups", Value: this.ActiveDirectoryAllowedUserGroups })
        parameters.push({ Name: "ActiveDirectoryAuthEnabled", Value: this.ActiveDirectoryAuthEnabled ? "true" : "false" })
        parameters.push({ Name: "AzureUseActiveDirectory", Value: this.AzureUseActiveDirectory ? "true" : "false" })
        parameters.push({ Name: "AzureMicrosoftGraphApiURL", Value: this.AzureMicrosoftGraphApiURL })
        parameters.push({ Name: "ActiveDirectoryDomain", Value: this.ActiveDirectoryDomain })
        parameters.push({ Name: "ActiveDirectoryServerPath", Value: this.ActiveDirectoryServerPath })
        parameters.push({ Name: "ClientID", Value: this.ClientID })
        parameters.push({ Name: "CredentialID", Value: this.CredentialID })
        parameters.push({ Name: "ClientSecret", Value: this.ClientSecret })
        parameters.push({ Name: "UserID", Value: this.UserID })
        parameters.push({ Name: "QuoVadisV2ApiURL", Value: this.QuoVadisV2ApiURL })
        parameters.push({ Name: "DashboardCacheEnabled", Value: this.DashboardCacheEnabled })
        parameters.push({ Name: "JobsExecutionTimeDocumentLifeCycle", Value: this.JobsExecutionTimeDocumentLifeCycle })
        parameters.push({ Name: "JobsExecutionTimeDelegations", Value: this.JobsExecutionTimeDelegations })
        parameters.push({ Name: "JobsExecutionTimeDataManagement", Value: this.JobsExecutionTimeDataManagement })
        parameters.push({ Name: "JobsExecutionTimeAlert", Value: this.JobsExecutionTimeAlert })
        parameters.push({ Name: "JobsExecutionTimeLicence", Value: this.JobsExecutionTimeLicence })
        parameters.push({ Name: "JobsExecutionTimeConnectedServices", Value: this.JobsExecutionTimeConnectedServices })
        parameters.push({ Name: "SAMLCertificate", Value: this.SAMLEnabled ? this.SAMLCertificate : "" })
        parameters.push({ Name: "SAMLEndpoint", Value: this.SAMLEnabled ? this.SAMLEndpoint : "" })
        parameters.push({ Name: "SupportedFileFormats", Value: this.SupportedFileFormats })
        parameters.push({ Name: "WebApiURL", Value: this.WebApiURL })
        parameters.push({ Name: "AutorecognitionApiURL", Value: this.AutorecognitionApiURL })
        parameters.push({ Name: "WebsiteURL", Value: this.WebsiteURL })
        parameters.push({ Name: "SwissIDLogin", Value: this.SwissIDLogin })
        parameters.push({ Name: "SwissIDPassword", Value: this.SwissIDPassword })
        parameters.push({ Name: "MicrosoftEntraClientId", Value: this.MicrosoftEntraClientId })
        parameters.push({ Name: "MicrosoftEntraClientSecret", Value: this.MicrosoftEntraClientSecret })
        parameters.push({ Name: "MicrosoftEntraIDDefaultOrganizationId", Value: this.MicrosoftEntraIDDefaultOrganizationId })
        return parameters;
    }
}
